module.exports = __webpack_public_path__ + "img/flow-arrow.2131ddd.png";